import { Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2} from '@angular/core';

@Component({
  selector: 'app-panel-controls',
  templateUrl: './panel-controls.component.html',
  styleUrls: ['./panel-controls.component.css']
})
export class PanelControlsComponent implements OnInit {

  public isCollapsed = false;
  public isRefreshing = false;
  public isPanelFullscreen = false;
  public fullscreenTooltip = 'Expand';
  public isClosed = false;

  @Input() panelRef;
  @Input() panelname;
  @Input() toolrefresh;
  @Input() toolcollapse;
  @Input() toolexpand;
  @Input() tooldismiss;

  @Output() onCollapsed = new EventEmitter();
  @Output() onRefresh = new EventEmitter();
  @Output() onRefreshDone = new EventEmitter();
  @Output() onExpand = new EventEmitter();
  @Output() onClose = new EventEmitter();


  private tempToolDismiss: boolean;
  private tempToolCollapse: boolean;

  constructor(private ele: ElementRef, private renderer: Renderer2) { }

  ngOnInit() {
    if (!this.panelRef) {
      this.panelRef = this.ele.nativeElement.parentElement.parentElement;
    }

    if (!this.panelname) {
      // try to get the parent panel id.. use as panelname prop (sent with events)
      this.panelname = this.panelRef.id;
    }
  }

  ToggleCollapse() {
    this.isCollapsed = !this.isCollapsed;
    const event = {
      name: this.panelname,
      value: this.isCollapsed
    };
    this.onCollapsed.emit(event);
  }

  // catch clicks to toggle panel refresh
  StartRefresh() {
    const csspinnerClass = 'csspinner';
    const spinner = 'load1';

    // method to clear the spinner when done
    const _this = this;
    function removeSpinner() {
      _this.renderer.removeClass(_this.panelRef, spinner);
      _this.renderer.removeClass(_this.panelRef, csspinnerClass);
      _this.isRefreshing = false;
      const event2 = {
        name: _this.panelname,
        panelRef: _this.panelRef,
        isRefreshing: _this.isRefreshing
      };
      _this.onRefreshDone.emit(event2);
    }

    // start showing the spinner
    this.renderer.addClass(this.panelRef, spinner);
    this.renderer.addClass(this.panelRef, csspinnerClass);

    // Trigger the event and send the panel object
    const event = {
      name: this.panelname,
      panelRef: this.panelRef,
      removeSpinnerCallback: removeSpinner,
      isRefreshing: this.isRefreshing
    };
    this.onRefresh.emit(event);
  }

  ToggleFullScreen() {

    this.isPanelFullscreen = !this.isPanelFullscreen;
    if (this.isPanelFullscreen) {
      this.tempToolCollapse = this.toolcollapse;
      this.tempToolDismiss = this.tooldismiss;
      this.tooldismiss = false;
      this.toolcollapse = false;
      this.fullscreenTooltip = 'Close Panel';
    } else {
      this.tooldismiss = this.tempToolDismiss;
      this.toolcollapse = this.tempToolCollapse;
      this.fullscreenTooltip = 'Expand';
    }
    const event = {
      panelname: this.panelname,
      panelRef: this.panelRef,
      isPanelFullscreen: this.isPanelFullscreen
    };
    this.onExpand.emit(event);
  }


  Close() {
    const col = this.panelRef.parentElement;
    this.isClosed = true;
    const event = {
      name: this.panelname,
      panelRef: this.panelRef,
      isClosed: this.isClosed
    };
    this.onClose.emit(event);

  }

}



// WEBPACK FOOTER //
// ./src/app/core.module/modules/panel.module/panel-controls/panel-controls.component.ts